export const environment = {
    production: true,
    apiUrl: 'https://apidev.anpryl.com/',
    local: false
};
